var $ = require('jquery');
var _ = require('underscore');
var Marionette = require('marionette');
var Activity = require('RecordActivityLog');
var Configuration = EY.Consultation.Lookups.Configuration;
var Dialog = require('Dialog');
var Entities = require('Entities');
var RecordAssignedTo = require('RecordAssignedTo');
var UserLookup = require('UserLookup');
var Labels = EY.Consultation.Labels;
var StatusType = EY.Consultation.Lookups.StatusType;

var View = Marionette.View.extend({

    regions: {
        user: '#user'
    },
    ui: {
        text: '#text',
        picklist: '#picklist'
    },
    template: '#recordActionReassign',
    onRender: function () {
        var approver = this.options.approver;
        var group = this.options.group;
        var record = this.options.record;
        var picklist = null;

        this.ui.text.html(record.get('statusTypeId') === StatusType.Draft || record.get('statusTypeId') === StatusType.ReturnForRevision ? Labels.MSG002 : Labels.MSG010);
        if (group && group.get('picklist')) {
            picklist = new Entities.Users();
            picklist.fetch({
                filter: { roles: { $elemMatch: { geographyId: approver.get('geographyId'), roleId: group.get('roleId') } }, active: true },
                select: { active:1, displayName: 1, email: 1, geography: 1, givenName: 1, gpn: 1, id:1, mailNickname: 1, modifiedBy: 1, modifiedOn: 1, upn: 1,
                    physicalDeliveryOfficeName: 1, givenName: 1, roles: { $elemMatch: { geographyId: approver.get('geographyId'), roleId: group.get('roleId') } } }
            });
        }
        UserLookup.show({ region: this.getRegion('user'), user: this.model, collection: picklist });
    }
});

module.exports.run = function (options) {
    var deferred = $.Deferred();
    var record = options.record;
    RecordAssignedTo.run(options); // Invoking this method to make sure assignedTo & assignedToGivenName is set if they're empty
    var approver = options.approvers.find({ approverGroupId: record.get('approverGroupId'), upn: record.get('assignedTo') });
    var group = options.groups.get(record.get('approverGroupId'));
    var user = new Entities.Approver({ id: 1, rank: 1 });

    Dialog.show({
        cancelLabel: Labels.No,
        headerLabel: Labels.Reassign,
        saveLabel: Labels.Yes,
        validate: user,
        modalBodyClass:'suggestion-modal',
        view: new View({
            approver: approver,
            group: group,
            model: user,
            record: record
        })
    }).done(function () {
        var name = user.get('givenName');
        var upn = user.get('upn');
        var gpn = user.get('gpn');

        if (options.approvers.filter({ upn: upn }).length === 0) {
            Activity.log(_.extend({ text: group ? Labels.Activity_ReassignRecord.replace('{0}', Labels['ApproverGroup_' + group.id]) : Labels.Activity_ReassignAtCreator }, options));
            if (!group && record.get('assignedTo') === record.get('createdBy')) {
                record.set({ createdBy: upn, creatorGivenName: name, creatorGPN: gpn });
            } else {
                approver.set({ givenName: name, upn: upn, gpn: gpn, displayName: user.get('displayName'), email: user.get('email') });
            }
            record.set({ assignedTo: upn, assignedToGivenName: name });
            deferred.resolve();
        } else {
            deferred.reject();
        }
    }).fail(function () {
        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
    });
    return deferred.promise();
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionReassign.js